import React from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getNoImageSVG, handleImageError } from '../../utils/imageUtils';
import { addProduct, removeProduct } from '../../Redux/Slice/selectedProductsSlice';
 

const Product = ({image, alt, price, checkName, name, description, sku, productId, section, productType, contentProductId}) => {
  const dispatch = useDispatch();
  const { selectedProducts } = useSelector(state => state.selectedProducts);
  
  // Vérifier si ce produit est déjà sélectionné
  const isProductSelected = selectedProducts.some(
    p => p.contentProductId === contentProductId && p.section === section
  );
  
  const [isChecked, setIsChecked] = useState(isProductSelected);

  const handleClick = () => {
    const newChecked = !isChecked;
    setIsChecked(newChecked);
    
    if (newChecked) {
      // Ajouter le produit
      dispatch(addProduct({
        product: {
          id: productId, // ID original du produit
          name,
          price: parseFloat(price),
          image,
          description,
          sku,
          productType
        },
        section,
        contentProductId, // ID du ContentProduct
        quantity: 1
      }));
    } else {
      // Retirer le produit
      dispatch(removeProduct({
        contentProductId,
        section
      }));
    }
  }

  return (
    <div className='col-md-3 col-sm-6 col-12 px-3 mb-5'>
        <div className="border  product-card pt-3 h-100" onClick={handleClick}>
            <div className="d-flex flex-column">
                <div className="image px-3 pb-3 flex-grow-1">
                    <img 
                        src={image} 
                        alt={alt || 'Product image'} 
                        className="img-fluid h-100" 
                        onError={handleImageError}
                        style={{objectFit: 'cover', minHeight: '200px'}}
                    />
                </div>
                <div className="description px-3  flex-grow-1 d-flex flex-column justify-content-between" style={{overflowWrap: 'break-word'}}>

                    <div>
                        <p className="product-name mb-2">{name}</p>
                        {/* {description && (
                            <p className="product-description mb-2 text-muted small" style={{fontSize: '0.8rem'}}>
                                {description.length > 100 ? `${description.substring(0, 100)}...` : description}
                            </p>
                        )} */}
                        {sku && (
                            <p className="product-sku mb-2 text-muted small" style={{fontSize: '0.7rem'}}>
                                SKU: {sku}
                            </p>
                        )}
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                        <p className="product-info mb-0">{price} € / m2</p>
                        <div className="checkbox-container">
                            <input 
                                type="checkbox" 
                                name={checkName} 
                                className="custom-checkbox" 
                                checked={isChecked}
                                onChange={handleClick}
                                readOnly
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Product